// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomMonitorQueueContainer {
    display: flex;
    flex-direction: column;
    direction: rtl;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    width: 450px;
    height: 450px;
    background-color: white;


}

.nextPatientTitle {
    border-radius: 20px;
    background-image: linear-gradient(to right, #4cc8f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    width: 95%;
    padding: 7px;
    font-weight: 700;
    font-size: 20pt;
    margin: 5px;
}

.numOfWaitPatientsTitle {
    font-weight: 600;
    font-size: 15pt;

}

.roomMonitorQueueContent {
    display: flex;
    flex-direction: column;
    direction: rtl;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 350px;
    height: 300px;
    background-color: white;
    margin-top: 15px;
}

.currentPatientNumber {
    color: #e92a0d;
    font-size: 100pt;
    font-weight: 700;
    margin-top: 20px;

}



.roomMonitorTitle {
    font-size: 30pt;
    font-weight: 700;
    border-bottom-left-radius: 100px;
    border-bottom-right-radius: 100px;

    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);
    background-size: 200% auto;
    color: white;
    width: 70%;
    padding: 7px;

}

.next3MonitorPatients {
    display: flex;
    align-items: center;
    font-weight: 600;
    margin-top: 5px;


}

.numOfWaitPatients {
    border-radius: 100px;
    color: white;
    width: 80px;
    margin-right: 10px;
    font-weight: 700;
    font-size: 15pt;
    background-color: red;
    

}

.numOfWaitPatientsContainer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-top: 25px;

    font-size: 10pt;
}

.curenntAndNextPatients {

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
}

.next3MonitorPatients .next:nth-child(1) {
    background-color: #87aff96e;
    /* כחול בהיר */

}

.next3MonitorPatients .next:nth-child(2) {
    background-color: #3b6ff27d;
    /* כחול בינוני */
}

.next3MonitorPatients .next:nth-child(3) {
    background-color: #3b6ff2;
    /* כחול כהה */

}


.next {
    color: white;
    /* padding: 2px 10px 2px 10px; */
    border-radius: 7px;
    font-weight: 700;
    font-size: 40pt;
    margin: 3px;
    width: 70px;
}

.nextPatientsContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
}

@media (max-width: 768px) {

    .currentPatientNumber {
        font-size: 30pt;
    }

    .roomMonitorTitle {
        font-size: 18pt;
        width: 60%;
    }
}



.numberRoomTitle{
    color: rgb(255, 255, 255);

}`, "",{"version":3,"sources":["webpack://./src/components/MonitorPage/RoomMonitorQueue.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;;;AAG3B;;AAEA;IACI,mBAAmB;IACnB,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;;AAEpB;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,iCAAiC;;IAEjC,kFAAkF;IAClF,0BAA0B;IAC1B,YAAY;IACZ,UAAU;IACV,YAAY;;AAEhB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;;;AAGnB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;;;AAGzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;;IAEhB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,aAAa;;AAEjB;;;AAGA;IACI,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;AACf;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,UAAU;IACd;AACJ;;;;AAIA;IACI,yBAAyB;;AAE7B","sourcesContent":[".RoomMonitorQueueContainer {\r\n    display: flex;\r\n    flex-direction: column;\r\n    direction: rtl;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    position: relative;\r\n    width: 450px;\r\n    height: 450px;\r\n    background-color: white;\r\n\r\n\r\n}\r\n\r\n.nextPatientTitle {\r\n    border-radius: 20px;\r\n    background-image: linear-gradient(to right, #4cc8f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 95%;\r\n    padding: 7px;\r\n    font-weight: 700;\r\n    font-size: 20pt;\r\n    margin: 5px;\r\n}\r\n\r\n.numOfWaitPatientsTitle {\r\n    font-weight: 600;\r\n    font-size: 15pt;\r\n\r\n}\r\n\r\n.roomMonitorQueueContent {\r\n    display: flex;\r\n    flex-direction: column;\r\n    direction: rtl;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n    width: 350px;\r\n    height: 300px;\r\n    background-color: white;\r\n    margin-top: 15px;\r\n}\r\n\r\n.currentPatientNumber {\r\n    color: #e92a0d;\r\n    font-size: 100pt;\r\n    font-weight: 700;\r\n    margin-top: 20px;\r\n\r\n}\r\n\r\n\r\n\r\n.roomMonitorTitle {\r\n    font-size: 30pt;\r\n    font-weight: 700;\r\n    border-bottom-left-radius: 100px;\r\n    border-bottom-right-radius: 100px;\r\n\r\n    background-image: linear-gradient(to right, #4ca0f9 0%, #3762f0 51%, #368cdc 100%);\r\n    background-size: 200% auto;\r\n    color: white;\r\n    width: 70%;\r\n    padding: 7px;\r\n\r\n}\r\n\r\n.next3MonitorPatients {\r\n    display: flex;\r\n    align-items: center;\r\n    font-weight: 600;\r\n    margin-top: 5px;\r\n\r\n\r\n}\r\n\r\n.numOfWaitPatients {\r\n    border-radius: 100px;\r\n    color: white;\r\n    width: 80px;\r\n    margin-right: 10px;\r\n    font-weight: 700;\r\n    font-size: 15pt;\r\n    background-color: red;\r\n    \r\n\r\n}\r\n\r\n.numOfWaitPatientsContainer {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-top: 25px;\r\n\r\n    font-size: 10pt;\r\n}\r\n\r\n.curenntAndNextPatients {\r\n\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n.next3MonitorPatients .next:nth-child(1) {\r\n    background-color: #87aff96e;\r\n    /* כחול בהיר */\r\n\r\n}\r\n\r\n.next3MonitorPatients .next:nth-child(2) {\r\n    background-color: #3b6ff27d;\r\n    /* כחול בינוני */\r\n}\r\n\r\n.next3MonitorPatients .next:nth-child(3) {\r\n    background-color: #3b6ff2;\r\n    /* כחול כהה */\r\n\r\n}\r\n\r\n\r\n.next {\r\n    color: white;\r\n    /* padding: 2px 10px 2px 10px; */\r\n    border-radius: 7px;\r\n    font-weight: 700;\r\n    font-size: 40pt;\r\n    margin: 3px;\r\n    width: 70px;\r\n}\r\n\r\n.nextPatientsContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n\r\n    .currentPatientNumber {\r\n        font-size: 30pt;\r\n    }\r\n\r\n    .roomMonitorTitle {\r\n        font-size: 18pt;\r\n        width: 60%;\r\n    }\r\n}\r\n\r\n\r\n\r\n.numberRoomTitle{\r\n    color: rgb(255, 255, 255);\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
